var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBxTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.91667 11.6666C2.91667 11.976 3.03958 12.2728 3.25838 12.4916C3.47717 12.7104 3.77391 12.8333 4.08333 12.8333H9.91667C10.2261 12.8333 10.5228 12.7104 10.7416 12.4916C10.9604 12.2728 11.0833 11.976 11.0833 11.6666V4.66663H12.25V3.49996H9.91667V2.33329C9.91667 2.02387 9.79375 1.72713 9.57496 1.50833C9.35616 1.28954 9.05942 1.16663 8.75 1.16663H5.25C4.94058 1.16663 4.64383 1.28954 4.42504 1.50833C4.20625 1.72713 4.08333 2.02387 4.08333 2.33329V3.49996H1.75V4.66663H2.91667V11.6666ZM5.25 2.33329H8.75V3.49996H5.25V2.33329ZM4.66667 4.66663H9.91667V11.6666H4.08333V4.66663H4.66667Z",
    fill: "#FF2E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 5.83337H6.41667V10.5H5.25V5.83337ZM7.58333 5.83337H8.75V10.5H7.58333V5.83337Z",
    fill: "#FF2E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxTrash);
export default __webpack_public_path__ + "static/media/bxTrash.534f7ff470395980cd1d4f4db23818a8.svg";
export { ForwardRef as ReactComponent };